export const CommonEnv = {
  captchaSiteKey: '6LdNiSQeAAAAAH4fwdxERGeMoEp3t6_CaclSYQi5'
};
